import { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';
import LazyLoad from 'react-lazy-load';
import Pen from 'dibs-icons/exports/Pen';

import styles from '../OverviewArticles.scss';

import { EditableArticleType } from '../OverviewArticles';

type Props = {
    article: EditableArticleType;
    articleCount: number;
    isEditMode: boolean;
    isVerticalLayout: boolean;
    onClick: () => void;
};

export const Display: FC<Props> = ({
    article,
    articleCount,
    isEditMode,
    isVerticalLayout,
    onClick,
}) => {
    const wrapperClass = classNames(styles.articleWrapper, 'colXs12', {
        [styles.articleEditWrapper]: isEditMode,
        ['colXl4']: articleCount === 3 && !isVerticalLayout,
        ['colXl6']: articleCount === 2 && !isVerticalLayout,
    });

    return (
        <div className={wrapperClass} onClick={onClick}>
            {isEditMode && <Pen className={styles.penIcon} />}
            {article.photoPath && (
                <div className={styles.articleImage}>
                    <LazyLoad offset={200}>
                        <img
                            src={`${article.photoPath}?width=200`}
                            className={styles.image}
                            alt={article.title || ''}
                        />
                    </LazyLoad>
                </div>
            )}
            <div className={styles.articleInfo}>
                <div className={styles.articleTitle}>{article.title}</div>
                <div className={styles.articleBody}>{article.description}</div>
                {!isEditMode && (
                    <a href={article.url || ''} className={styles.articleLink}>
                        <FormattedMessage
                            id="abt.designProfile.overview.articles.readMore"
                            defaultMessage="Read More"
                        />
                    </a>
                )}
            </div>
        </div>
    );
};

Display.displayName = 'Display';
